import { Type } from "class-transformer";
import { Dates } from "src/modules/utils/shared/dates";

export class DevMail {
    //netgen start
    id: string;
    subject: string;
    sender: string;
    @Type(() => Date)
    sentDate: Date;
    isBugReport = false;
    customer: string;
    product: string;
    subProduct: string;
    //netgen end

    count = 0;
    score = 0;

    getScore(): number {
        let diffDays = Dates.diffDays(this.sentDate, new Date());
         return 5 / (1 + diffDays)**0.72;
    }
}
